import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Web3ReactProvider } from "@web3-react/core";
import Routes from "./routes";
import {
  getLibrary,
  AppContext,
} from "./components/walletsManagment/connectors";
import { TRACKING_ID } from "./app/index";
import {
  getAppConfigs,
  getConfigsFireStore,
  getDecriptedEnv,
} from "./actions/DataActions";
import {
  VIEW_CENTER,
  VIEW_MAX_ZOOM,
  VIEW_ZOOM,
  VIEW_PROJECTION,
} from "./utils/constants/map";
import CustomLoader from "./layout/CustomLoader";
import { setUpFirebase } from "./utils/utilities/firebase";
import messages from "./utils/constants/messages";
import { Provider } from "react-redux";
import { store } from "./redux/store";
function App() {
  const eth_zoomView = useRef({
    center: VIEW_CENTER,
    zoom: VIEW_ZOOM,
    maxZoom: VIEW_MAX_ZOOM,
    projection: VIEW_PROJECTION,
  });

  const cardano_zoomView = useRef({
    center: [15.2, 23.8],
    zoom: 9,
    maxZoom: 12,
    minZoom: 8,
    projection: VIEW_PROJECTION,
  });

  const [appState, setState] = useState({
    cardanoAddress: localStorage.getItem("cardnao"),
    eith_auth_token: localStorage.getItem("eith_t"),
    cardano_auth_token: localStorage.getItem("cardno_t"),
    k: null,
    configurationsCompleted: false,
    cardanoWalletId: localStorage.getItem("cardano_wallet"),
  });

  const providerValue = {
    cardanoAddress: appState.cardanoAddress,
    eithAuthToken: appState.eith_auth_token,
    cardano_auth_token: appState.cardano_auth_token,
    isCardanoEnabled: appState.configs?.is_cardano == 1,
    cardanoWalletId: appState.cardanoWalletId,
    eth_zoomView: eth_zoomView,
    cardano_zoomView: cardano_zoomView,
    values: appState.k, //appState.k ? JSON.parse(getDecriptedEnv(appState.k)) : {},

    setEthZoomView: (view) => {
      eth_zoomView.current = view;
    },

    setCardanoZoomView: (view) => {
      cardano_zoomView.current = view;
    },

    setEithAuthToken: (token) => {
      if (token) {
        localStorage.setItem("eith_t", token);
      } else {
        localStorage.removeItem("eith_t");
      }
      setState((state) => ({
        ...state,
        eith_auth_token: token,
      }));
    },

    setCardnaoAuthToken: (token) => {
      if (token) {
        localStorage.setItem("cardno_t", token);
      } else {
        localStorage.removeItem("cardno_t");
      }
      setState((state) => ({
        ...state,
        cardano_auth_token: token,
      }));
    },

    setCardanoAddress: (address) => {
      if (address) {
        localStorage.setItem("cardnao", address);
      } else {
        localStorage.removeItem("cardnao");
      }
      setState((state) => ({
        ...state,
        cardanoAddress: address,
      }));
    },
    setCardanoWallet: (wallet) => {
      if (wallet) {
        localStorage.setItem("cardano_wallet", wallet);
      } else {
        localStorage.removeItem("cardano_wallet");
      }
      setState((state) => ({
        ...state,
        cardanoWalletId: wallet,
      }));
    },
    setEithProvider: (provider) => {
      if (provider) {
        localStorage.setItem("e_provider", provider);
      } else {
        localStorage.removeItem("e_provider");
      }
    },
    getEithProvider: () => {
      return localStorage.getItem("e_provider");
    },
  };

  const googleTagManager = () => {
    (function (w, d, s, l, i) {
      try {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode?.insertBefore(j, f);
      } catch (error) {}
    })(window, document, "script", "dataLayer", TRACKING_ID);
  };

  const getConfigs = async () => {
    try {
      const configs = await getConfigsFireStore();

      setState((state) => ({ ...state, configs }));
    } catch (error) {}
  };
  const getKeys = () => {
    getAppConfigs()
      .then((res) => {
        if (res.status == false) {
          toast(messages.something_wrong, { autoClose: 60000 });
          setState((state) => ({ ...state, k: null }));
        } else {
          setState((state) => ({ ...state, k: res }));
        }
      })
      .catch(() => {
        toast(messages.something_wrong);
        setState((state) => ({ ...state, k: null }));
      });
  };
  useEffect(() => {
    if (appState.k) {
      setUpFirebase(appState.k);
      googleTagManager();
      getConfigs();
      setState((state) => ({ ...state, configurationsCompleted: true }));
    }
  }, [appState.k]);

  useEffect(() => {
    getKeys();
  }, []);

  return (
    <Provider store={store}>
      <AppContext.Provider value={providerValue}>
        <Web3ReactProvider getLibrary={getLibrary}>
          {appState.configurationsCompleted ? <Routes /> : <CustomLoader />}
          <ToastContainer />
        </Web3ReactProvider>
      </AppContext.Provider>
    </Provider>
  );
}

export default App;
